import React from 'react'
import styled from '@emotion/styled'

import { fontSize3XSmall, fontFamilyOpenSans, highlightBlueBase, grayLight30, white } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import { AnchorButton } from '../generic/Basics'
import FAQModal from '../generic/FAQModal'

export default ({ setShowModal, shouldSticky, dealerIsDirectToKBBv2 }) => {
  const showScroll = shouldSticky
  const isDesktop = BrowserUtils.isDesktop()
  const sell2KbbV2FooterText = 'Kelley Blue Book is here to help. Text or call: '
  const defaultFooterText = 'Kelley Blue Book is here to help:'
  return (
    <StyledHelpDiv id={'helpFooter'} shouldSticky={shouldSticky}>
      <div>
        {dealerIsDirectToKBBv2 ? sell2KbbV2FooterText : defaultFooterText} {dealerIsDirectToKBBv2 ? <StyledA href="tel:1-513-572-1181"> 513-572-1181</StyledA> : <StyledA href="tel:1-866-559-5268">866-559-5268</StyledA>}
      </div>
      <div>Mon - Fri: 8 a.m. - 8 p.m. ET, Sat: 9 a.m. - 6 p.m. ET</div>
      <div>
        {!dealerIsDirectToKBBv2 && (
          <StyledUl>
            <StyledLi>
              <AnchorButton
                onClick={() => {
                  setShowModal('FAQ')
                }}>
                FAQs
              </AnchorButton>
            </StyledLi>
            <StyledLi>
              <StyledA href="mailto:instantcashoffer@kbb.com">Email Kelley Blue Book</StyledA>
            </StyledLi>
          </StyledUl>
        )}
      </div>
      <FAQModal setShowModal={setShowModal} />
      {showScroll && (
        <ScrollTop>
          <AnchorButton
            isDesktop={isDesktop}
            onClick={() => {
              BrowserUtils.isBrowser &&
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                })
            }}>
            Back To Top
          </AnchorButton>
        </ScrollTop>
      )}
    </StyledHelpDiv>
  )
}

const ScrollTop = styled.div`
width: 100%;
text-align: right;
}
`
const StyledHelpDiv = styled.div`
  border: 1px solid ${grayLight30};
  background-color: ${white};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${fontFamilyOpenSans};
  font-size: ${fontSize3XSmall};
  line-height: 17px;
  padding: 20px;
  z-index: 2;
  ${p =>
    p.shouldSticky &&
    `position: sticky;
  top: 0px;`}
`
const StyledA = styled.a`
  text-decoration: none;
  color: ${highlightBlueBase};
  font: inherit;
  :hover {
    text-decoration: underline;
  }
`
const StyledUl = styled.ul`
  margin: 0px;
  padding: 0px;
`
const StyledLi = styled.li`
  display: inline-block;
  margin: 0px 1em;
`
